import type { SolutionEntity } from '@ipen-portal/ipen-entity-model';

import { Select } from '@backstage/ui';

import classes from './SolutionsHomeCardFilter.module.css';

type Props = {
  onFilterChange: (tag: null | string) => void;
  solutions: readonly SolutionEntity[];
  value: null | string;
};

export const SolutionsHomeCardFilter = ({ onFilterChange, solutions, value }: Props) => {
  const options = [
    { id: 'all', label: 'All solutions' },
    ...[...new Set(solutions.flatMap(solution => solution.metadata.tags ?? []))]
      .toSorted((left, right) => left.localeCompare(right))
      .map(tag => ({ id: `tag:${tag}`, label: tag })),
  ];

  return (
    <Select
      aria-label="Filter solutions by tag"
      className={classes.root}
      onChange={key => onFilterChange(typeof key === 'string' && key.startsWith('tag:') ? key.slice(4) : null)}
      options={options}
      placeholder="Select filter options"
      value={value === null ? 'all' : `tag:${value}`}
    />
  );
};
